<template>
  <v-row
    class="timer_style"
    :style="{
      'background-image': 'url(' + `${getBackgroundImage}` + ')',
    }"
  >
    <div class="transparentLayer">
      <v-avatar
        v-if="iconShow"
        class="project_timer_avatar"
        width="80px"
        height="80px"
        style="border: 5px solid gray; cursor: pointer"
        @click="$router.push({path: '/timer'})"
      >
        <v-img src="@/assets/image/Nekologic.png"></v-img>
      </v-avatar>
      <v-col class="nav_bar_tittle center" v-if="nameShow">
        <h2 class="mb-0 timerName" v-b-tooltip.hover :title="getProjectName">
          {{ getProjectName }}
        </h2>
      </v-col>
      <v-col
        class="center button_play_stop"
        v-if="buttonStartFlag && buttonShow"
      >
        <v-btn
          class="timer_button"
          fab
          small
          color="#707070"
          @click="startTimer"
        >
          <v-icon color="black"> mdi-play</v-icon>
        </v-btn>
      </v-col>
      <v-col
        class="center button_play_stop"
        v-if="buttonStopFlag && buttonShow"
      >
        <v-btn
          class="timer_button"
          fab
          dark
          small
          color="#707070"
          @click="stopTimer"
        >
          <v-icon color="black"> mdi-stop</v-icon>
        </v-btn>
      </v-col>
      <v-col class="center">
        <h2 class="mb-0 time_count">{{ time }}</h2>
      </v-col>
    </div>
  </v-row>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {
  returnHHMMSSFormat,
  GetCurrentTimeUtc,
  GetCurrentProjectTimerData,
  calculateProjectTime,
  today,
  UpdateCurrentTimerData,
  calculateOverallTimeDiffInHour,
  CheckIfTimerIsRunningToday,
} from "@/Utilites/timerHelper";
import {TIMER_V1_SYNC_INTERVAL_MS} from "@/config/timerV1Config";
import {isLegacyTimerRetired} from "@/config/legacyTimerConfig";
import {resolveTimerUserId} from "@/services/timerActor";
import DEFAULT_CONSTANTS from "@/Utilites/constants";

export default {
  name: "Timer",
  props: ["buttonShow", "iconShow", "nameShow"],
  data() {
    return {
      form: {},
      data: {},
      timeBegan: null,
      timeStopped: null,
      started: null,
      running: false,
      time: "00:00:00",
      buttonStartFlag: true,
      buttonStopFlag: false,
      backGroundImage: null,
      projectName: "Timer",
      currentProjectTimeData: {hours: 0, minutes: 0, seconds: 0},
      v1SyncTimer: null,
    };
  },
  computed: {
    ...mapGetters([
      "getProjects",
      "userProfileData",
      "getToken",
      "getCurrentActiveTimer",
      "getTimers",
      "getTimerState",
      "getCurrentActiveTimerTime",
      "isTimerV1Active",
      "getTimerV1Session",
    ]),
    getProjectName() {
      return this.projectName;
    },
    getBackgroundImage() {
      if (this.backGroundImage === null)
        return "/hr/NekoLogicGreetingCardFinal.png";
      else return this.backGroundImage;
    },
    checkCurrentState() {
      if (this.isTimerV1Active) {
        const v1 = this.getTimerV1Session;
        if (v1 && v1.status === "active") {
          return mapV1ToWatchRow(v1);
        }
        return null;
      }
      return CheckIfTimerIsRunningToday(this.getTimers);
    },
  },
  watch: {
    checkCurrentState: async function (value) {
      if (this.isTimerV1Active) {
        if (value !== null && GetCurrentTimeUtc() > value.timer_started_at) {
          const currentProject = this.getProjects.find(
            (element) => element.id === value.project_id
          );
          if (currentProject === undefined) {
            this.backGroundImage = "/hr/NekoLogicGreetingCardFinal.png";
            this.projectName = "Timer";
          } else {
            this.backGroundImage = currentProject.project_image_url;
            this.projectName = currentProject.project_name;
          }
          this.timeBegan = value.timer_started_at;
          this.start();
        } else {
          this.backGroundImage = "/hr/NekoLogicGreetingCardFinal.png";
          this.projectName = "Timer";
          this.stop();
        }
        return;
      }
      if (value !== null && GetCurrentTimeUtc() > value.timer_started_at) {
        let data = {...value};
        let startTime = data.timer_started_at;
        let endTime = GetCurrentTimeUtc();
        let timeDiff = calculateOverallTimeDiffInHour(startTime, endTime);
        let hours = (data.hours || 0) + timeDiff;
        data.hours_with_timer = hours;
        data.hours = hours;
        data.working_hours = hours;
        this.ACTIVATE_TIMER(data);
        let currentProject = this.getProjects.find(
          (element) => element.id === value.project_id
        );
        if (currentProject === undefined) {
          this.backGroundImage = "/hr/NekoLogicGreetingCardFinal.png";
          this.projectName = "Timer";
        } else {
          this.backGroundImage = currentProject.project_image_url;
          this.projectName = currentProject.project_name;
        }
        this.timeBegan = startTime;
        this.start();
      } else {
        this.backGroundImage = "/hr/NekoLogicGreetingCardFinal.png";
        this.projectName = "Timer";
        this.stop();
      }
    },
    getTimerV1Session() {
      if (!this.isTimerV1Active) return;
      this.applyV1SessionUi(this.getTimerV1Session);
    },
    getCurrentActiveTimerTime(value) {
      if (this.getTimerState) this.time = value;
    },
  },
  mounted() {
    if (this.isTimerV1Active) {
      this.bootstrapTimerV1();
    }
  },
  /* eslint-disable vue/no-deprecated-destroyed-lifecycle */
  beforeDestroy() {
    if (this.v1SyncTimer) clearInterval(this.v1SyncTimer);
  },
  methods: {
    ...mapActions([
      "CREATE_TIMER_REQUEST",
      "UPDATE_TIMER_REQUEST",
      "SET_TIMER_TIME",
      "SYNC_TIMER_V1_SESSION",
      "TIMER_V1_START",
      "TIMER_V1_STOP",
      "showSnackBar",
    ]),
    ...mapMutations(["ACTIVATE_TIMER"]),
    async bootstrapTimerV1() {
      await this.SYNC_TIMER_V1_SESSION();
      this.applyV1SessionUi(this.getTimerV1Session);
      if (this.v1SyncTimer) clearInterval(this.v1SyncTimer);
      this.v1SyncTimer = setInterval(() => {
        this.SYNC_TIMER_V1_SESSION();
      }, TIMER_V1_SYNC_INTERVAL_MS);
    },
    applyV1SessionUi(session) {
      if (!session || session.status !== "active") {
        this.stop();
        return;
      }
      const row = mapV1ToWatchRow(session);
      this.timeBegan = row.timer_started_at;
      const currentProject = this.getProjects.find(
        (el) => el.id === session.project_id
      );
      if (!currentProject) {
        this.backGroundImage = "/hr/NekoLogicGreetingCardFinal.png";
        this.projectName = "Timer";
      } else {
        this.backGroundImage = currentProject.project_image_url;
        this.projectName = currentProject.project_name;
      }
      this.start();
    },
    start() {
      this.buttonStartFlag = false;
      this.buttonStopFlag = true;
      if (this.isTimerV1Active) {
        this.time = this.getCurrentActiveTimerTime || "00:00:00";
        this.running = true;
        return;
      }
      const currentProjectTimer = {...this.getCurrentActiveTimer};
      const baseH = Number(currentProjectTimer.hours) || 0;
      this.currentProjectTimeData = GetCurrentProjectTimerData(baseH);
      if (this.running) return;
      if (this.timeBegan === null) {
        this.timeBegan = GetCurrentTimeUtc();
      }
      if (this.started) clearInterval(this.started);
      this.started = setInterval(this.clockRunning, 10);
      this.running = true;
    },
    stop() {
      this.time = "00:00:00";
      this.running = false;
      this.timeBegan = null;
      this.buttonStartFlag = true;
      this.buttonStopFlag = false;
      if (this.started) clearInterval(this.started);
      this.started = null;
    },
    clockRunning() {
      if (this.isTimerV1Active) return;
      const active = this.getCurrentActiveTimer;
      if (!active || active.id === undefined) {
        this.stop();
        return;
      }
      const baseH = Number(active.hours) || 0;
      this.currentProjectTimeData = GetCurrentProjectTimerData(baseH);
      const began = this.timeBegan;
      const timer = calculateProjectTime(began, this.currentProjectTimeData);
      this.time = returnHHMMSSFormat(timer);
      this.SET_TIMER_TIME(this.time);
    },
    async startTimer() {
      if (isLegacyTimerRetired()) return;
      if (this.isTimerV1Active) {
        try {
          const viewDate =
            this.$store.state.timer.viewingTimerLogDate || today();
          await this.TIMER_V1_START({
            project_id: null,
            task_description: "",
            timer_log_date: viewDate,
          });
          this.timeBegan =
            (this.getTimerV1Session && this.getTimerV1Session.started_at) ||
            GetCurrentTimeUtc();
          this.start();
        } catch (e) {
          console.error("[timer v1] start failed", e);
          await this.showSnackBar({
            text: `Timer could not start: ${(e && e.message) || e}`,
            color: DEFAULT_CONSTANTS.error,
          });
        }
        return;
      }
      const uid = resolveTimerUserId(this.userProfileData);
      if (uid == null) {
        console.error("[timer] missing user_id in JWT");
        return;
      }
      this.form.user_id = uid;
      this.form.hours_with_timer = 0;
      this.form.hours = 0;
      this.form.working_hours = 0;
      this.form.is_submitted = true;
      this.form.timer_started_at = GetCurrentTimeUtc();
      this.form.timer_initiated_at = this.form.timer_started_at;
      this.form.timer_log_date = today();
      this.form.log_date = this.form.timer_log_date;
      this.form.project_id = null;
      let data = {...this.getCurrentActiveTimer};
      if (data.id !== undefined) {
        let updateTimer = UpdateCurrentTimerData(data);
        await this.UPDATE_TIMER_REQUEST({...updateTimer});
      }
      await this.CREATE_TIMER_REQUEST({...this.form});
      this.start();
    },
    async stopTimer() {
      if (isLegacyTimerRetired()) return;
      if (this.isTimerV1Active) {
        try {
          await this.TIMER_V1_STOP({});
        } catch (e) {
          console.error("[timer v1] stop failed", e);
        }
        this.stop();
        return;
      }
      this.stop();
      let data = {...this.getCurrentActiveTimer};
      if (data.id !== undefined) {
        let updateTimer = UpdateCurrentTimerData(
          data,
          this.getCurrentActiveTimerTime
        );
        await this.UPDATE_TIMER_REQUEST({...updateTimer});
      }
    },
  },
};

function mapV1ToWatchRow(session) {
  return {
    id:
      session.legacy_timer_log_id != null
        ? session.legacy_timer_log_id
        : session.id,
    timer_started_at: session.started_at,
    project_id: session.project_id,
    hours: session.elapsed_hours || 0,
  };
}
</script>

<style scoped>
.timer_style {
  border-radius: 30px;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: center;
  background-size: cover;
  overflow: hidden;
  box-shadow: 0px 1px 5px 1px rgba(0, 12, 22, 0.75);
  -webkit-box-shadow: 0px 1px 5px 1px rgba(0, 12, 22, 0.75);
  -moz-box-shadow: 0px 1px 5px 1px rgba(0, 12, 22, 0.75);
}
.transparentLayer {
  display: flex;
  background-color: hsla(210, 55%, 45%, 0.5);
  padding: 5px;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav_bar_tittle {
  text-shadow: 1px 1px 3px black;
}
.time_count {
  text-shadow: 1px 1px 3px black;
}
.timerName {
  width: 125px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media only screen and (max-width: 1165px) {
  .nav_bar_tittle {
    display: none;
  }
}
@media only screen and (max-width: 992px) {
  .time_count {
    font-size: 25px;
  }
}
@media only screen and (max-width: 325px) {
  .button_play_stop {
    padding: 0;
  }
}
</style>
